/* eslint-disable react/display-name */
import { GradientPath } from "@xessential/gradient-path";
import React, { forwardRef, useEffect, useRef } from "react";

import { calculatePathSegments } from "../utils/drawPath";

interface PlayerPathProps {
  crashed: boolean;
  points?: [number, number, number][];
  attempt?: number;
  width?: number;
  theme?: Record<string, string>;
}

const PlayerPath = forwardRef(
  ({ points, crashed, width = 8, theme }: PlayerPathProps, ref: any) => {
    const gradientPath = useRef<any>();
    useEffect(() => {
      if (!ref?.current) return;

      if (!points?.length) {
        document.querySelectorAll(".gradient-path").forEach(function (element) {
          element.parentNode.removeChild(element);
        });
        document.querySelector("#crashText")?.remove();
        return;
      }
      try {
        gradientPath.current = new GradientPath({
          path: ref.current,
          segments: Math.floor(points?.length ? points.length / 5 : 1),
          samples: 15,
          precision: 0,
        });
      } catch (e) {
        console.warn(e);
        return;
      }

      const fill = points?.length
        ? calculatePathSegments(points, 12)
        : [
            { pos: 0, color: "red" },
            { pos: 1, color: "red" },
          ];

      gradientPath.current?.render({
        type: "path",
        fill,
        // stroke: fill,
        width,
        transform: "translate(50, 100)",
      });

      if (!crashed) return;

      const crashIcon = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "text"
      );

      crashIcon.setAttribute("id", "crashText");
      crashIcon.setAttribute("text-anchor", "middle");
      crashIcon.setAttribute("font-size", "48px");
      crashIcon.setAttribute("opacity", "1");
      crashIcon.setAttribute("z", "1000");
      crashIcon.setAttribute("x", points[points.length - 1][0].toString());
      crashIcon.setAttribute(
        "y",
        (points[points.length - 1][1] + 24).toString()
      );

      crashIcon.innerHTML = "❌";
      ref.current?.parentElement?.appendChild(crashIcon);
    }, [points.length, ref.current]);

    return (
      <path
        id="playerPath"
        ref={ref}
        strokeWidth={width}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={
          theme?.background === theme?.road
            ? theme?.crashBarrier
            : theme?.background
        }
        fill="none"
        // transform="translate(50, 100)"
        d="M 0, 0"
      />
    );
  }
);

export default PlayerPath;
